import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateAfterTodayValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) return null; // no validem si no hi ha valor

  const inputDate = new Date(value);
  const today = new Date();

  // Posem l'hora a 00:00:00 per comparar només dates
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return inputDate >= today ? null : { dateNotAfterToday: true };
}
